<template>
  <div>
    <el-dialog :title="$t('text.edit')"
               :visible="dialogShow"
               width="30%"
               @open="init"
               @close="handleDialog"
               :close-on-click-modal="false">
      <div>
        <div style="font-size: 16px; display: flex">
          <i class="el-icon-info" style="color: #e6a23c; font-size: 22px; margin-right: 6px"></i>{{ $t('message.tieredBillingSubTitle') }}
        </div>
        <p>
          <el-form ref="form" :model="form" :rules="rules" label-width="120px">
            <el-form-item :label="$t('text.baseFeeRate')"
                          prop="basePaymentRate">
              <el-input v-model="form.basePaymentRate"
                        :disabled="1 === 1"
                        type="text"
                        size="small"
                        style="width: 300px"/>
            </el-form-item>

            <el-form-item :label="$t('text.whetherToEnable')"
                          :label-width="formLabelWidth"
                          prop="openTieredBilling">
              <el-col :span="12">
                <el-select v-model="form.openTieredBilling"
                           :placeholder="$t('message.chooseOne')">
                  <el-option :label="$t('tieredBillingStatus.00')" value="00"></el-option>
                  <el-option :label="$t('tieredBillingStatus.01')" value="01"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('text.tieredBillingMode')"
                          :label-width="formLabelWidth"
                          prop="tieredBillingMode">
              <el-col :span="12">
                <el-select v-model="form.tieredBillingMode"
                           :placeholder="$t('message.chooseOne')"
                           :disabled="form.openTieredBilling === '00'">
                  <el-option :label="$t('tieredBillingMode.00')" value="00"></el-option>
                  <el-option :label="$t('tieredBillingMode.01')" value="01"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('text.firstTier')"
                          prop="paymentRateStaging1">
              <el-input v-model="form.paymentRateStaging1"
                        :disabled="form.openTieredBilling === '00'"
                        type="text"
                        size="small"
                        style="width: 140px"/>
              &nbsp;&nbsp;{{ $t('text.feeRate') }}：
              <el-input v-model="form.paymentRateStagingRate1"
                        :disabled="form.openTieredBilling === '00'"
                        type="text"
                        size="small"
                        style="width: 140px"/>
            </el-form-item>

            <el-form-item :label="$t('text.secondTier')"
                          prop="paymentRateStaging2">
              <el-input v-model="form.paymentRateStaging2"
                        :disabled="form.openTieredBilling === '00'"
                        type="text"
                        size="small"
                        style="width: 140px"/>
              &nbsp;&nbsp;{{ $t('text.feeRate') }}：
              <el-input v-model="form.paymentRateStagingRate2"
                        :disabled="form.openTieredBilling === '00'"
                        type="text"
                        size="small"
                        style="width: 140px"/>
            </el-form-item>

            <el-form-item :label="$t('text.thirdTier')"
                          prop="paymentRateStaging3">
              <el-input v-model="form.paymentRateStaging3"
                        :disabled="form.openTieredBilling === '00'"
                        type="text"
                        size="small"
                        style="width: 140px"/>
              &nbsp;&nbsp;{{ $t('text.feeRate') }}：
              <el-input v-model="form.paymentRateStagingRate3"
                        :disabled="form.openTieredBilling === '00'"
                        type="text"
                        size="small"
                        style="width: 140px"/>
            </el-form-item>
          </el-form>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="handleDialog">{{ $t('text.cancel') }}</el-button>
          <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },
  data() {
    return {
      dialogShow: this.show,
      formLabelWidth: "120px",
      form: {
        appId: '',
        openTieredBilling: '',
        tieredBillingMode: '',
        basePaymentRate: '',
        paymentRateStaging1: '',
        paymentRateStaging2: '',
        paymentRateStaging3: '',
        paymentRateStagingRate1: '',
        paymentRateStagingRate2: '',
        paymentRateStagingRate3: '',
      },
      rules: {},
    }
  },
  methods: {
    init() {
      this.form = this.formData
    },
    handleDialog() {
      this.form = {
        appId: '',
        openTieredBilling: '',
        tieredBillingMode: '',
        basePaymentRate: '',
        paymentRateStaging1: '',
        paymentRateStaging2: '',
        paymentRateStaging3: '',
        paymentRateStagingRate1: '',
        paymentRateStagingRate2: '',
        paymentRateStagingRate3: '',
      }
      this.$refs['form'].resetFields()
      this.$emit('update:show', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {
            ...this.form,
          }
          this.$axios
              .post('/merchant/tieredBillingUpdate', params)
              .then(res => {
                if (res.code === 200) {
                  this.$notify({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                    type: 'success',
                  })
                  this.$emit('update:show', false)
                  this.$bus.$emit('refresh') //通知刷新
                } else {
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                  })
                }
              })
        }
      })
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>